/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './star-rating.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../../../../app/modules/employee/pages/star-rating/star-rating.component';
import * as i4 from '@angular/forms';
const styles_StarRatingComponent:any[] = [i0.styles];
export const RenderType_StarRatingComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_StarRatingComponent,data:{}});
function View_StarRatingComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),5,'span',([] as any[]),
      (null as any),[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.rate((_v.context.index + 1))) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵeld(2,0,(null as any),(null as any),2,'i',[['class','fa']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(3,278528,
          (null as any),0,i2.NgClass,[i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,
              i1.Renderer],{klass:[0,'klass'],ngClass:[1,'ngClass']},(null as any)),
      i1.ɵpod(4,{'fa-star':0,'fa-star-o':1,'disabled':2}),(_l()(),i1.ɵted(-1,(null as any),
          ['\n  ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = 'fa';
    const currVal_1:any = _ck(_v,4,0,(_v.context.index < _co.rating),(_v.context.index >= _co.rating),
        _co.disabled);
    _ck(_v,3,0,currVal_0,currVal_1);
  },(null as any));
}
export function View_StarRatingComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'div',[['class',
      'star-rating']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i3.StarRatingComponent = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.onTouchedHandler()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),
      i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StarRatingComponent_1)),
      i1.ɵdid(3,802816,(null as any),0,i2.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(-1,
          (null as any),['\n']))],(_ck,_v) => {
    var _co:i3.StarRatingComponent = _v.component;
    const currVal_0:any = _co.stars;
    _ck(_v,3,0,currVal_0);
  },(null as any));
}
export function View_StarRatingComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),2,'app-star-rating',
      ([] as any[]),(null as any),(null as any),(null as any),View_StarRatingComponent_0,
      RenderType_StarRatingComponent)),i1.ɵprd(5120,(null as any),i4.NG_VALUE_ACCESSOR,
      (p0_0:any) => {
        return [p0_0];
      },[i3.StarRatingComponent]),i1.ɵdid(2,114688,(null as any),0,i3.StarRatingComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,2,0);
  },(null as any));
}
export const StarRatingComponentNgFactory:i1.ComponentFactory<i3.StarRatingComponent> = i1.ɵccf('app-star-rating',
    i3.StarRatingComponent,View_StarRatingComponent_Host_0,{rating:'rating',disabled:'disabled'},
    {ratingChange:'ratingChange'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvc3Rhci1yYXRpbmcvc3Rhci1yYXRpbmcuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0Q6L2luZXRwdWIvd3d3cm9vdC9rYWl6ZW4tbmcvc3JjL2FwcC9tb2R1bGVzL2VtcGxveWVlL3BhZ2VzL3N0YXItcmF0aW5nL3N0YXItcmF0aW5nLmNvbXBvbmVudC50cyIsIm5nOi8vL0Q6L2luZXRwdWIvd3d3cm9vdC9rYWl6ZW4tbmcvc3JjL2FwcC9tb2R1bGVzL2VtcGxveWVlL3BhZ2VzL3N0YXItcmF0aW5nL3N0YXItcmF0aW5nLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvc3Rhci1yYXRpbmcvc3Rhci1yYXRpbmcuY29tcG9uZW50LnRzLlN0YXJSYXRpbmdDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2IGNsYXNzPVwic3Rhci1yYXRpbmdcIiAoY2xpY2spPVwib25Ub3VjaGVkSGFuZGxlcigpXCI+XHJcbiAgPHNwYW4gKm5nRm9yPVwibGV0IHN0YXIgb2Ygc3RhcnM7IGxldCBpID0gaW5kZXhcIiAoY2xpY2spPVwicmF0ZShpICsgMSlcIj5cclxuICAgIDxpIGNsYXNzPVwiZmFcIiBbbmdDbGFzc109XCJ7XHJcbiAgICAgICdmYS1zdGFyJzogaSA8IHJhdGluZyxcclxuICAgICAgJ2ZhLXN0YXItbyc6IGkgPj0gcmF0aW5nLFxyXG4gICAgICAnZGlzYWJsZWQnOiBkaXNhYmxlZFxyXG4gICAgfVwiPjwvaT5cclxuICA8L3NwYW4+XHJcbjwvZGl2PiIsIjxhcHAtc3Rhci1yYXRpbmc+PC9hcHAtc3Rhci1yYXRpbmc+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQ0U7TUFBQTtRQUFBO1FBQUE7UUFBZ0Q7VUFBQTtVQUFBO1FBQUE7UUFBaEQ7TUFBQSxnQ0FBc0U7TUFDcEU7VUFBQSxpRUFBQTtVQUFBO3lCQUFBO2FBQWMsNkNBSVA7VUFBQTs7SUFKSjtJQUFXO1FBQUE7SUFBZCxXQUFHLFVBQVcsU0FBZDs7OztvQkFGSjtNQUFBO0lBQUE7SUFBQTtJQUF5QjtNQUFBO01BQUE7SUFBQTtJQUF6QjtFQUFBLGdDQUFzRCw0Q0FDcEQ7YUFBQTthQUFBOzRCQUFBLHlDQU1PO1VBQUE7O0lBTkQ7SUFBTixXQUFNLFNBQU47Ozs7b0JDREY7TUFBQTtvQ0FBQTtNQUFBO1FBQUE7TUFBQSxtQ0FBQTtNQUFBO0lBQUE7Ozs7OyJ9



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/modules/employee/pages/star-rating/star-rating.component.ngfactory.ts